import { render, staticRenderFns } from "./CircleIconButton.vue?vue&type=template&id=4d5c02c6&scoped=true"
import script from "./CircleIconButton.vue?vue&type=script&lang=js"
export * from "./CircleIconButton.vue?vue&type=script&lang=js"
import style0 from "./CircleIconButton.vue?vue&type=style&index=0&id=4d5c02c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c02c6",
  null
  
)

export default component.exports